/**
 * 发票类型
 */
enum InvoiceType {
    E_INVOICE = "E_INVOICE",

    NORMAL_INVOICE = "NORMAL_INVOICE",

    VALUE_ADDED_TAX_INVOICE = "VALUE_ADDED_TAX_INVOICE",
}

export default InvoiceType;
